import { render, staticRenderFns } from "./ChecklistActivity1.vue?vue&type=template&id=0da89a38&"
import script from "./ChecklistActivity1.vue?vue&type=script&lang=js&"
export * from "./ChecklistActivity1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports